!((document, Drupal, once) => {
  'use strict';
  Drupal.behaviors.siteHeader = {
    attach: function(context) {
      const self = this;

      // Using `call` so each function has itself as its `this` variable.
      // Needed to call one's `close` function from inside the other.
      self.initMainMenu.call(self.initMainMenu, context);
      self.initSearch.call(self.initSearch, context);
    },
    initMainMenu: function(context) {
      const mainMenuContainerClass = 'site-header__item--menu';
      const mainMenuButtonClass = 'site-header__main-menu-expand';

      const mainMenuContainerOnce = once(
        'menu-container',
        '.' + mainMenuContainerClass,
        context
      );

      mainMenuContainerOnce.forEach((mainMenuContainer) => {
        const mainMenuButton = context.querySelector('.' + mainMenuButtonClass);

        if (!mainMenuContainer || !mainMenuButton) {
          return;
        }

        /**
         * function to toggle "open" class on menu list
         * @param {Object} event - Event object
         * @return {undefined}
         */
        const open = () => {
          mainMenuButton.classList.add(mainMenuButtonClass + '--expanded');
          mainMenuButton.setAttribute('aria-expanded', 'true');
          mainMenuContainer.classList.add(
            mainMenuContainerClass + '--expanded'
          );
          mainMenuContainer.classList.add(
            mainMenuContainerClass + '--has-been-expanded'
          );
          Drupal.behaviors.siteHeader.initSearch.close();
        };

        this.open = open;

        /**
         * function to close all "open" menu items when the user resizes the window
         * @return {undefined}
         */
        const close = () => {
          mainMenuButton.classList.remove(mainMenuButtonClass + '--expanded');
          mainMenuButton.setAttribute('aria-expanded', 'false');
          mainMenuContainer.classList.remove(
            mainMenuContainerClass + '--expanded'
          );
        };

        this.close = close;

        const toggle = () => {
          if (
            mainMenuButton.classList.contains(
              mainMenuButtonClass + '--expanded'
            )
          ) {
            close();
            return;
          }

          open();
        };

        let timeout = 0;

        const throttledClose = () => {
          window.clearTimeout(timeout);
          timeout = window.setTimeout(() => {
            close();
          }, 100);
        };

        mainMenuButton.addEventListener('click', toggle);
        window.addEventListener('resize', throttledClose);
      });
    },
    initSearch: function(context) {
      const searchArea = once(
        'search-area-header',
        '.site-header__search-widgets',
        context
      );

      searchArea.forEach((element) => {
        const searchBox = element.querySelector('.site-header__search-box');
        const searchToggleButton = element.querySelector(
          '.site-header__search-toggle-button'
        );
        const logo = context.querySelector('.site-header__item--logo');

        let searchBarWidthTimeout = 0;

        const setSearchBarWidth = () => {
          window.clearTimeout(searchBarWidthTimeout);
          searchBarWidthTimeout = window.setTimeout(() => {
            // Start at the right edge of the logo.
            const boxStart =
              logo.getBoundingClientRect().right + window.scrollX;
            // End in the middle of the toggle button.
            const toggleRect = searchToggleButton.getBoundingClientRect();
            const boxEnd =
              toggleRect.width / 2 + toggleRect.left + window.scrollX;
            searchBox.style.width = `${boxEnd - boxStart}px`;
          }, 100);
        };

        const open = () => {
          element.classList.add('site-header__search-widgets--expanded');
          Drupal.behaviors.siteHeader.initMainMenu.close();
        };

        this.open = open;

        const close = () => {
          element.classList.remove('site-header__search-widgets--expanded');
        };

        this.close = close;

        setSearchBarWidth();
        window.addEventListener('resize', setSearchBarWidth);

        searchToggleButton.addEventListener('click', () => {
          if (
            element.classList.contains('site-header__search-widgets--expanded')
          ) {
            close();
            return;
          }

          open();
        });
      });
    }
  };
  // eslint-disable-next-line no-undef
})(document, Drupal, once);
